import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeviceManagementComponent } from './device-management.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DeviceTypeComponent } from './device-type/device-type.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { DeviceNameComponent } from './device-name/device-name.component';
import { DeviceInformationComponent } from './device-information/device-information.component';
import { DeviceAddedComponent } from './device-added/device-added.component';
import { MatRadioModule } from '@angular/material/radio';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@NgModule({
  declarations: [
    DeviceManagementComponent,
    DeviceTypeComponent,
    DeviceNameComponent,
    DeviceInformationComponent,
    DeviceAddedComponent,
  ],
  imports: [
    CommonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    FormsModule,
    MatRadioModule,
    TranslateModule
  ],
  exports: [DeviceManagementComponent],
  providers: [
    LocalizationService,
    TranslateModule
  ],
})
export class DeviceManagementModule {}
